/*!
 * Generate a countdown bar graph.
 */
import './styles/TimedBar.scss';
import CoreComponent from './CoreComponent';

export default class TimedBar extends CoreComponent {
    componentDidMount() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setStatePrev({
                    run: true,
                });
            });
        });
    }

    componentDidUpdate({ time }) {
        if (time !== this.props.time) {
            this.setStatePrev({
                run: false,
            }).then(() => this.componentDidMount())
        }
    }

    render() {
        let {
            type = 'default',
            time = 1000,
            style = {},
            finished = () => { },
            ...rest
        } = this.props;

        return (
            <div
                key={`TimedBar-${time}`}
                className={`TimedBar ${type}-timedbar`}
                style={
                    {
                        width: this.state.run ? '0%' : '100%',
                        transition: `width ${time / 1000}s linear`,
                        ...style,
                    }
                }
                onTransitionEnd={finished}
                {...rest}
            />
        );
    }
}
